<template>
  <div class="d-flex align-center justify-center">
    <v-card
      class="my-auto"
      :class="{ 'animated': isAnimated, 'color-flash': isAnimated}"
      color="#F1EDE6"
      width="100%"
      min-width="30%"
      height="auto"
    >
      <v-card-title>
        <div class="matched-header d-flex justify-space-between">
          <span class="prop-name">{{ itemData.noiseaware.name }}</span>
          <span class="prop-id">ID: {{ itemData.noiseaware.id }}</span>
        </div>
      </v-card-title>
      <v-card-text class="matched-address">
        {{ itemData.noiseaware.address }}
      </v-card-text>
    </v-card>
    <div class="d-flex justify-center align-center">
      <div class="separator-line" />
      <v-btn
        color="#CECECE"
        class="unmatch-btn"
        @click="() => $emit('handleUnmatch',matched)"
      >
        UNMATCH
      </v-btn>
      <div class="separator-line" />
    </div>
    <v-card
      class="my-auto"
      :class="{ 'animated': isAnimated, 'color-flash': isAnimated}"
      color="#F1EDE6"
      width="100%"
      min-width="30%"
      height="auto"
    >
      <v-card-title>
        <div class="matched-header d-flex justify-space-between">
          <span class="prop-name">{{ itemData.partner.name }}</span>
          <span class="prop-id">ID: {{ itemData.partner.id }}</span>
        </div>
      </v-card-title>
      <v-card-text class="matched-address">
        {{ itemData.partner.address }}
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'MatchedPropertyComponent',
    props: {
      matched: {
        type: Object,
      },
      newestMatch: {
        type: Object,
        default: null,
      },
    },
    data: () => ({
      itemData: {},
      isAnimated: false,
    }),
    created () {
      if (this.newestMatch) {
        this.itemData = this.newestMatch
        this.isAnimated = true
      } else {
        this.itemData = this.matched
        this.isAnimated = false
      }
    },
  }
</script>
<style lang="scss">
.animated {
  animation: colorFlash 1s linear;
  color: white !important;
  .matched-address {
    color: white !important;
  }
}
@keyframes colorFlash {
  0% { background-color: rgba(80, 132, 123, .3);}
  50% { background-color: rgba(80, 132, 123, 1);}
  100% { background-color: rgba(80, 132, 123, .1); }
}
.color-flash {
  animation-name: colorFlash;
}
 .matched-header {
    width:100%;
    font-size: 15px;
    line-height:18px;
    .prop-name {
      font-weight: 700;
      width: 80%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .prop-id {
      white-space: nowrap;
    }
  }
  .matched-address {
    width: 80%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .separator-line {
    height: 2px;
    background-color: $success;
    width: auto;
    min-width: 40px;
  }
  .unmatch-btn.v-btn:not(.v-btn--round).v-size--default {
    padding: 0 10px !important;
    min-width: 116px !important;
  }
</style>
